export default function IconInsertImageBottom({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Insert-Image-Bottom Streamline Ultimate">
        <path
          id="Vector"
          d="M15.1094 2.17044H7.20312"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M17.2656 5.04544H7.20312"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M15.1094 7.92044H7.20312"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M3.60938 15.8267L5.04688 13.6704H0.734375"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M3.60938 11.5142L5.04688 13.6704"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M7.92188 11.5142H15.8281C15.8281 11.5142 16.5469 11.5142 16.5469 12.2329V15.1079C16.5469 15.1079 16.5469 15.8267 15.8281 15.8267H7.92188C7.92188 15.8267 7.20312 15.8267 7.20312 15.1079V12.2329C7.20312 12.2329 7.20312 11.5142 7.92188 11.5142Z"
          fill="white"
        />
        <path
          id="Vector_7"
          d="M16.5469 13.6719V12.2344C16.5469 12.0438 16.4711 11.8609 16.3364 11.7261C16.2016 11.5914 16.0187 11.5156 15.8281 11.5156H7.92188C7.73125 11.5156 7.54843 11.5914 7.41364 11.7261C7.27885 11.8609 7.20312 12.0438 7.20312 12.2344V13.6719H16.5469Z"
          fill="#ECFDF5"
        />
        <path
          id="Vector_8"
          d="M7.92188 11.5142H15.8281C15.8281 11.5142 16.5469 11.5142 16.5469 12.2329V15.1079C16.5469 15.1079 16.5469 15.8267 15.8281 15.8267H7.92188C7.92188 15.8267 7.20312 15.8267 7.20312 15.1079V12.2329C7.20312 12.2329 7.20312 11.5142 7.92188 11.5142Z"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
